import React, { useState } from "react";
import AddIndividualPatient from "./add-individual-patient";
import Header from "../common/header/Header";
import AddBulkUpload from "./bulk-upload/add-bulk-upload";



const AddPatient = () => {
    const [activeTab, setActiveTab] = useState("individual")
    return (
        <>
            <Header backbutton={true} headertitle="Add Patient" />

            <div className="main-body pl-8 pt-0 mb-[100px]">
                <div className="">
                    <div
                        className="flex cursor-pointer mb-[10px] mt-[30px]"
                    >
                        <div
                            style={{ marginRight: '40px', color: activeTab === 'individual' ? '#245CEA' : 'black' }}
                            className="text-[18px] text-center font-semibold"
                            onClick={() => setActiveTab('individual')}
                        >
                            Individual

                            {activeTab === 'individual' ? <div className="bg-[#245CEA] h-1 relative top-[12px] rounded-sm"></div> : <div className=" h-1 relative top-5 z-10 rounded-sm"></div>}
                        </div>
                        <div
                            style={{ color: activeTab === 'bulkupload' ? '#245CEA' : 'black' }}
                            className="text-[18px] text-center font-semibold"
                            onClick={() => setActiveTab('bulkupload')}
                        >
                            Bulk Upload
                            {activeTab === 'bulkupload' ? <div className="bg-[#245CEA] h-1 relative top-[12px] rounded-sm"></div> : <div className=" h-1 relative top-5 z-10 rounded-sm"></div>}
                        </div>
                    </div>{/*Tabs ended */}
                    <div className="bg-[#C8D6E6] h-[1px] border"></div>
                </div>
                <div className="">
                    {activeTab !== 'bulkupload' ?
                        <AddIndividualPatient /> : <AddBulkUpload />}
                </div>
            </div>
        </>

    )
}

export default AddPatient;